function controlClients() {
    function init() {
        jQuery('.block-slider-con-zoom__slick').slick({
            //slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            centerMode: true,
            //centerPadding: '200px',
            autoplaySpeed: 4000,
            arrows: true,
            pauseOnHover: true,
            mobileFirst: true,
            nextArrow: `<button class='u-slick-next u-slick-arrow'><i class="fa-solid fa-chevron-right"></i></button>`,
            prevArrow: `<button class='u-slick-prev u-slick-arrow'><i class="fa-solid fa-chevron-left"></i></button>`,
            responsive: [
                {
                    breakpoint: 2500,
                    settings: {
                        slidesToShow: 3,
                        centerPadding: '40px',
                    }
                },
                {
                    breakpoint: 1900,
                    settings: {
                        //slidesToShow: 3,
                        centerPadding: '400px',
                    }
                },
                {
                    breakpoint: 1366,
                    settings: {
                        centerPadding: '300px',
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        //slidesToShow: 3,
                        centerPadding: '40px',
                    }
                },
            ]
        });
    }
    init();
}
controlClients();